/**
 * The four P0 subjects shown on Child Home (decision D-14.2). Only English has
 * a playable learning journey in this slice; the other subjects are honest
 * placeholders until their own PO-approved slices define topics, activities
 * and grading. Display data only: no pedagogy or grading lives here.
 */

export type SubjectCode = 'english' | 'mathematics' | 'physics' | 'chemistry'

export interface Subject {
  readonly code: SubjectCode
  readonly name: string
  readonly icon: string
  /** True only where a real learning entry point exists in this build. */
  readonly available: boolean
}

export const SUBJECTS: readonly Subject[] = [
  { code: 'english', name: 'Tiếng Anh', icon: '🔤', available: true },
  { code: 'mathematics', name: 'Toán', icon: '➗', available: false },
  { code: 'physics', name: 'Vật lý', icon: '🔭', available: false },
  { code: 'chemistry', name: 'Hóa học', icon: '⚗️', available: false },
]
